import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <AppSection />
        <CarouselSection />
        <CommentsSection />
        <IndexSection />
        <TopicsSection />
        <FaqSection />
        <ContactSection />
        <CardsSection />
        <UpdatesSection />
        <FeaturesSection />
        <MediaSection />
        <AboutSection />
        <RankingSection />
      </main>
      <Footer />
    </div>
  );
}